import { BusEvent } from '@web/common';

export class AdminBannerChangedBusEvent extends BusEvent {}
